// @ts-nocheck
import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

const ADMIN_ROLES = [
  'rlevents_super_admin',
  'rlevents_tenant_admin',
  'super_admin',
  'admin',
  'rlevents_admin',
];

export function RequireAdminRole({ children }: { children: ReactNode }) {
  const { user, loading } = useAuth();
  const { data: isAdmin, isLoading } = useQuery({
    enabled: !!user,
    queryKey: ['is-admin', user?.id],
    queryFn: async () => {
      try {
        const { data: ur, error } = await (supabase as any)
          .from('user_roles')
          .select('role')
          .eq('user_id', user!.id);
        if (error) {
          console.error('RequireAdminRole: user_roles query failed', error);
          return false;
        }
        if (ur?.some((r: any) => ADMIN_ROLES.includes(r.role))) return true;
        return false;
      } catch (err) {
        console.error('RequireAdminRole: unexpected error', err);
        return false;
      }
    },
  });

  if (loading || isLoading) return <div className="p-8 text-center">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (!isAdmin) {
    return (
      <div className="p-8 text-center">
        <h2 className="text-xl font-semibold mb-2">Access denied</h2>
        <p className="text-muted-foreground">This page is admin-only.</p>
      </div>
    );
  }
  return <>{children}</>;
}

export default RequireAdminRole;
